import { useMemo } from "react";
import { SpeedLimitReportDetails } from "../models/SpeedLimitReportData";
import AddInIds from "@/constants/AddInIds";
import { CastedAddInData, useRawAddinData } from "@/hooks/addins/useAddinData";

export function useSpeedLimitReports() {
  const { data: rawData = [], ...rest } = useRawAddinData<{ dataType?: string }>(
    AddInIds.geotabAddin,
  );

  const reports = useMemo(
    () =>
      rawData.filter(
        (item): item is CastedAddInData<SpeedLimitReportDetails> =>
          item.details.dataType === "speedLimitReport",
      ),
    [rawData],
  );

  return { data: reports, ...rest };
}
